import { createContext, memo, useRef, useContext } from "react";

export const RowContext = createContext({});

export default memo(({ children }) => {
  const shareRefs = useRef({
  });
  const rowContextData = {
    rowShareRefs: shareRefs.current,
  };
  
  return (
    <RowContext.Provider value={rowContextData}>{children}</RowContext.Provider>
  );
});

export const useRowContext = () => {
  return useContext(RowContext);
}
